export const admin = "ADMIN";

export const rootProtectedPath = "explore";

export const scopeActions = {
	READ: { name: "READ", key: "read" },
	CREATE: { name: "CREATE", key: "create" },
	UPDATE: { name: "UPDATE", key: "update" },
	PUBLISH: { name: "PUBLISH", key: "publish" },
};

export const departments = {
	DESIGNER: { name: "DESIGNER", key: "DESIGNER" },
	BUYING_PLANNING: { name: "BUYING & PLANNING", key: "BUYING_PLANNING" },
	HR_ADMIN: { name: "HR & ADMIN", key: "HR_ADMIN" },
	SOURCING: { name: "SOURCING", key: "SOURCING" },
	MDM: { name: "MDM", key: "MDM" },
	STUDIO: { name: "STUDIO", key: "STUDIO" },
	CATALOGUE: { name: "CATALOGUE", key: "CATALOGUE" },
};

export const services = {
	CREATE_STYLE: { name: "CREATE STYLE", key: "CREATE_STYLE", department: departments.DESIGNER },
	FABRIC_TRIMS: { name: "FABRIC TRIMS", key: "FABRIC_TRIMS", department: departments.DESIGNER },
	BUYING: { name: "BUYING ", key: "BUYING", department: departments.BUYING_PLANNING },
	STORE_PROJECTION: { name: "STORE PROJECTION ", key: "STORE_PROJECTION", department: departments.BUYING_PLANNING },
	STYLES_DASHBOARD: { name: "STYLES DASHBOARD", key: "STYLES_DASHBOARD", department: departments.DESIGNER },
	ATTRIBUTES: { name: "ATTRIBUTES", key: "ATTRIBUTES", department: departments.MDM },
	ATTRIBUTE_GROUPS: { name: "ATTRIBUTE GROUPS", key: "ATTRIBUTE_GROUPS", department: departments.MDM },
	PRODUCTION_ALLOCATION: { name: "ATTRIBUTE GROUPS", key: "ATTRIBUTE_GROUPS", department: departments.MDM },
	USERS: { name: "USERS", key: "USERS", department: departments.HR_ADMIN },
	MERCHANT_SAMPLE_DATA: { name: "MERCHANT SAMPLE DATA", key: "MERCHANT_SAMPLE_DATA", department: departments.SOURCING },
	CREATE_SHOOT: { name: "CREATE SHOOT", key: "CREATE_SHOOT", department: departments.STUDIO },
	ALL_SHOOTS: { name: "ALL SHOOTS", key: "ALL_SHOOTS", department: departments.STUDIO },
	SHOOT_ARCHIVE: { name: "SHOOT ARCHIVE", key: "SHOOT_ARCHIVE", department: departments.STUDIO },
	CREATE_SHOOT_COSTING: { name: "CREATE SHOOT COSTING", key: "CREATE_SHOOT_COSTING", department: departments.STUDIO },
	ALL_SHOOT_COSTINGS: { name: "ALL SHOOT COSTINGS", key: "ALL_SHOOT_COSTINGS", department: departments.STUDIO },
	SHOOT_ATTRIBUTES: { name: "SHOOT ATTRIBUTES", key: "SHOOT_ATTRIBUTES", department: departments.STUDIO },
	MODAL_PROFILE_ATTRIBUTES: { name: "MODAL PROFILE ATTRIBUTES", key: "MODAL_PROFILE_ATTRIBUTES", department: departments.STUDIO },
	CREATE_MODAL_PROFILE: { name: "CREATE MODAL PROFILE", key: "CREATE_MODAL_PROFILE", department: departments.STUDIO },
	ALL_MODAL_PROFILES: { name: "ALL MODAL PROFILES", key: "ALL_MODAL_PROFILES", department: departments.STUDIO },
	STUDIO_SAMPLE_INWARD: { name: "STUDIO SAMPLE INWARD", key: "STUDIO_SAMPLE_INWARD", department: departments.STUDIO },
	CREATE_OPEN_COSTING: { name: "CREATE OPEN COSTING", key: "CREATE_OPEN_COSTING", department: departments.SOURCING },
	OPEN_COSTING_DASHBOARD: { name: "OPEN COSTING DASHBOARD", key: "OPEN_COSTING_DASHBOARD", department: departments.SOURCING },
	ALL_OPEN_COSTINGS: { name: "ALL OPEN COSTINGS", key: "ALL_OPEN_COSTINGS", department: departments.SOURCING },
	STYLE_FARBRIC_MASTER: { name: "STYLE FARBRIC MASTER", key: "STYLE_FARBRIC_MASTER", department: departments.SOURCING },
	STYLE_FARBRIC_DETAILS: { name: "STYLE DETAILS", key: "STYLE_FARBRIC_DETAILS", department: departments.SOURCING },
	STYLE_BlOCK_MASTER: { name: "STYLE BLOCK MASTER", key: "STYLE_BlOCK_MASTER", department: departments.CATALOGUE },
};

export const scopes = {
	FABRIC_CATEGORY: {
		name: "Fabric Category",
		key: "fabric_category",
		resource: services.STYLE_FARBRIC_MASTER.key,
		actions: [scopeActions.READ.key, scopeActions.CREATE.key, scopeActions.UPDATE.key],
		options: [
			{ name: "KNIT", key: "KNIT" },
			{ name: "WOVEN", key: "WOVEN" },
		],
	},
	STYLE_CATEGORY: {
		name: "Style Category",
		key: "style_category",
		resource: services.CREATE_STYLE.key,
		actions: [scopeActions.READ.key, scopeActions.CREATE.key, scopeActions.UPDATE.key],
		options: [],
	},
};
export const custom = {
	STYLE_VIEWER: { name: "STYLE_VIEWER", key: "STYLE_VIEWER" },
	STYLE_REVIEWER: { name: "STYLE REVIEWER", key: "STYLE_REVIEWER" },
	STYLE_FARBRIC_MASTER_VIEWER: { name: "STYLE FARBRIC MASTER VIEWER", key: "STYLE_FARBRIC_MASTER_VIEWER" },
	STYLE_BLOCK_MASTER_VIEWER: { name: "STYLE BLOCK MASTER VIEWER", key: "STYLE_BLOCK_MASTER_VIEWER" },
	SAMPLE_INWARD_VIEWER: { name: "SAMPLE_INWARD_VIEWER", key: "SAMPLE_INWARD_VIEWER" },
	COSTING_VIEWER: { name: "COSTING VIEWER", key: "COSTING_VIEWER" },
	PRODUCTION_ALLOC_PUBLISHER: { name: "PRODUCTION_ALLOC_PUBLISHER", key: "PRODUCTION_ALLOC_PUBLISHER" },
	COSTING_PUBLISHER: { name: "COSTING PUBLISHER", key: "COSTING_PUBLISHER" },
	SHOOT_VIEWER: { name: "SHOOT VIEWER", key: "SHOOT_VIEWER" },
	SHOOT_COSTING_VIEWER: { name: "SHOOT VIEWER", key: "SHOOT_COSTING_VIEWER" },
	MODAL_PROFILE_VIEWER: { name: "MODAL PROFILE VIEWER", key: "MODAL_PROFILE_VIEWER" },
	STYLE_PUBLISHER: { name: "STYLE PUBLISHER", key: "STYLE_PUBLISHER" },
	SHOOT_PUBLISHER: { name: "SHOOT PUBLISHER", key: "SHOOT_PUBLISHER" },
	SHOOT_COSTING_PUBLISHER: { name: "SHOOT COSTING PUBLISHER", key: "SHOOT_COSTING_PUBLISHER" },
	MODAL_PROFILE_PUBLISHER: { name: "SHOOT PUBLISHER", key: "SHOOT_PUBLISHER" },
	PRODUCTION_ALLOC_PUBLISHER: { name: "PRODUCTION_ALLOC_PUBLISHER", key: "PRODUCTION_ALLOC_PUBLISHER" },
};
export const externalTypes = {
	SUPPLIER: { name: "Supplier", key: "SUPPLIER" },
};

export const userTypes = {
	internal: "INTERNAL",
	external: "EXTERNAL",
};
